<template>
  <v-container class="site-page site-page--wide site-stack" tag="main">
    <SitePageHeader :summary="titles.projectsDescription"
                    :title="titles.projectsPage"
                    class="case-studies__header">
      <template v-slot:actions>
        <v-btn :to="{path: constants.contactPath}"
               class="site-action site-action--secondary"
               color="primary"
               outline>
          <v-icon left>mail</v-icon>
          {{ titles.contactPage }}
        </v-btn>
      </template>
    </SitePageHeader>

    <div class="case-study-grid">
      <CaseStudyCard :caseStudy="caseStudy" :key="caseStudy.route" v-for="caseStudy in caseStudies"/>
    </div>
  </v-container>
</template>

<style lang="stylus" scoped>
.case-studies__header >>> .site-page-header__content
  max-width 1050px

.case-study-grid
  display flex
  flex-wrap wrap
  justify-content center
  gap var(--site-grid-gap)

.case-study-grid > *
  flex 0 1 calc(33.333333% - 16px)
  min-width 0

@media (max-width: $site-bp-tablet)
  .case-study-grid > *
    flex-basis calc(50% - 10px)

@media (max-width: $site-bp-mobile)
  .case-study-grid > *
    flex-basis 100%
</style>

<script lang="ts">
import {Component} from 'vue-property-decorator'
import PortalPageBase from '@/view/PortalPageBase'
import CaseStudyCard from '@/view/CaseStudies/CaseStudyCard.vue'
import SitePageHeader from '@/view/SitePageHeader.vue'
import {breadcrumbList, canonicalUrl, pageMetaInfo, socialCardPath, stripHtml} from '@/model/Seo'
import {brandName} from '@/model/Brand'

@Component({components: {CaseStudyCard, SitePageHeader}})
export default class CaseStudies extends PortalPageBase {
  pageTitle = this.titles.projectsPage

  get caseStudies() {
    return this.model.projects.featured
  }

  metaInfo(): any {
    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          name: this.titles.projectsPage,
          description: this.titles.projectsDescription,
          url: canonicalUrl(this.constants.projectsPath),
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: this.caseStudies.map((caseStudy, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              url: canonicalUrl(this.constants.projectPath(caseStudy.route)),
              name: stripHtml(caseStudy.title),
              description: stripHtml(caseStudy.subtitle)
            }))
          }
        },
        breadcrumbList([
          {name: brandName, path: '/'},
          {name: this.titles.homePage, path: this.constants.introductionPath},
          {name: this.titles.projectsPage, path: this.constants.projectsPath}
        ])
      ]
    }
    return pageMetaInfo(
      this.titles.projectsSeoTitle,
      this.titles.projectsDescription,
      this.constants.projectsPath,
      socialCardPath(this.constants.projectsPath),
      structuredData
    )
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    super.beforeRouteEnter(to, from, next)
  }
}
</script>
